import { operatorRequiresValue } from "../Components/filters/operators";

/**
 * Build FilterBuilder / metadata API filters from URL search params (filter_{field}).
 */
export function buildMetadataFiltersFromSearchParams(searchParams) {
  const filters = [];
  const processedFields = new Set();

  searchParams.forEach((value, key) => {
    if (
      key.endsWith("_operator") ||
      key.endsWith("_logic") ||
      key.endsWith("_label") ||
      !key.startsWith("filter_")
    ) {
      return;
    }

    const field = key.replace("filter_", "");
    if (processedFields.has(field)) return;
    processedFields.add(field);

    const operator = searchParams.get(`filter_${field}_operator`) || "contains";
    const requiresValue = operatorRequiresValue(operator);

    if (!requiresValue || value) {
      let filterValue = requiresValue ? value : null;

      if (requiresValue && filterValue) {
        if (["equals", "not_equals", "in", "not_in"].includes(operator)) {
          const parts = filterValue.split(",").map((v) => v.trim());
          const allNumeric = parts.every((v) => /^\d+$/.test(v));
          filterValue = allNumeric
            ? parts.map((v) => Number(v))
            : parts.map((v) => v.toLowerCase());
        } else if (["between", "not_between"].includes(operator)) {
          filterValue = filterValue.split(",").map((v) => v.trim());
        }
      }

      filters.push({ field, operator, value: filterValue });
    }
  });

  return filters;
}
